export type ACLResource = string;

export type ACLAction = string;

export const ACCESS_POLICY_EFFECT = {
  ALLOW: 'allow',
  DENY: 'deny',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ACCESS_POLICY_EFFECT = (typeof ACCESS_POLICY_EFFECT)[keyof typeof ACCESS_POLICY_EFFECT];

/**
 * Normalized Access Policies
 */
export type AccessPolicies<T extends AccessPolicyStatement = AccessPolicyStatement> = Record<
  ACLResource,
  readonly T[]
>;

export type AccessPolicyStatement = {
  readonly actions: readonly ACLAction[];
  readonly intersect_conditions?: readonly string[];
  readonly conditions?: readonly string[];
  readonly effect: ACCESS_POLICY_EFFECT;
};

export type AccessPolicyStatementFilter = (statement: AccessPolicyStatement) => boolean;

export type AccessPolicyConditionEvaluator = (condition: string) => boolean;
